// frontend/src/pages/NotFound.js
//
// The app had no catch-all route, so any unmatched URL rendered header and
// footer with an empty middle — under the homepage's title. Google reads a blank
// HTTP 200 as a soft 404 and it tells the visitor nothing.
//
// noindex is set deliberately: this page should never itself appear in search.
import '../custom.css'

import React from 'react'
import { Container, Button } from 'react-bootstrap'
import { Link } from 'react-router-dom'

import Seo from '../components/Seo'

const LINKS = [
  ['Schedule posts', '/post-scheduling'],
  ['Content calendar', '/calendar-view'],
  ['Bulk posting', '/bulk-posting'],
  ['Link in bio', '/link-in-bio'],
  ['Plans & pricing', '/plans'],
  ['Support articles', '/p/support'],
]

export default function NotFound () {
  return (
    <>
      <Seo
        title='Page not found'
        description='That page does not exist. Here are the pages people usually want.'
        noindex
      />

      <section className='py-5'>
        <Container style={{ maxWidth: 640 }} className='text-center'>
          <p className='text-muted fw-bold mb-2' style={{ letterSpacing: '.1em' }}>404</p>
          <h1 className='fw-bold mb-3'>We couldn&rsquo;t find that page</h1>
          <p className='text-muted fs-5 mb-4'>
            It may have moved when we rebuilt the site. Here is where most people are heading.
          </p>

          <div className='d-flex flex-wrap justify-content-center gap-2 mb-4'>
            {LINKS.map(([label, to]) => (
              <Link key={to} to={to} className='btn btn-outline-primary btn-sm'>{label}</Link>
            ))}
          </div>

          <Button variant='primary' href='/'>Back to the homepage</Button>
        </Container>
      </section>
    </>
  )
}
